module.exports = __webpack_public_path__ + "img/Landing-page_PE-image.6815ec5c.png";